import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Wheel } from 'react-custom-roulette';
import { getRoulettePrizes, saveRouletteResult, toKstIso } from '../utils/firestoreApi';
import { Timestamp } from 'firebase/firestore';

const RouletteContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  color: white;
  /* padding: 20px; */
  box-sizing: border-box;
`;

const RouletteCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 30px;
  backdrop-filter: blur(10px);
  box-shadow: rgba(0, 0, 0, 0.3) 0px 8px 32px;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 20px;
    max-width: 95vw;
  }

  @media (max-width: 480px) {
    padding: 15px;
    max-width: 98vw;
    border-radius: 12px;
  }
`;

const Title = styled.h1`
  text-align: center;
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
`;

const Subtitle = styled.p`
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

const WheelContainer = styled.div`
  /* margin: 20px 0; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SpinButton = styled.button`
  padding: 15px 30px;
  border: none;
  border-radius: 25px;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--primary-gradient);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
  margin: 20px 0;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 480px) {
    padding: 12px 24px;
    font-size: 1rem;
    border-radius: 20px;
  }
`;

const ChallengeButton = styled.button`
  padding: 8px 16px;
  background: var(--primary-gradient);
  color: white;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: pre-line;
  line-height: 1.2;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-shadow: none;
  border: none;

  &:hover {
    background: var(--primary-gradient);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
  }

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 0.7rem;
  }
`;

const ResultModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
`;

const ResultCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

  @media (max-width: 480px) {
    padding: 30px 20px;
    border-radius: 15px;
  }
`;

const ResultTitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: ${props => props.$isWin ? '#ff3369' : '#666'};
  ${props => props.hasAlreadyWon && `
    font-size: 1.3rem;

    @media (max-width: 480px) {
      font-size: 1.2rem;
    }
  `}
`;

const ResultMessageText = styled.div`
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6;
  text-align: center;
  white-space: pre-line;
`;

const PrizeHighlight = styled.span`
  background: linear-gradient(45deg, #FFD700, #FFA500);
  color: white;
  padding: 4px 8px;
  border-radius: 8px;
  font-weight: bold;
  margin: 0 2px;
  box-shadow: 0 2px 4px rgba(255, 215, 0, 0.3);
`;

const ResultButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--primary-gradient);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
  }

  ${props => ((props.gameType === 'puzzle' && props.gameStage === 1) || props.gameType === 'dripBattle') ? `
    border: 2px solid rgba(66, 66, 66, 0.59);
    background: rgba(255, 255, 255, 0.1);
    color: rgba(29, 29, 29, 0.7);
    box-shadow: none;

    &:hover {
      background: rgb(255, 255, 255);
      transform: translateY(-2px);
      box-shadow: none;
    }
  ` : ''}
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: white;
  font-size: 1.1rem;
`;

const ErrorMessage = styled.div`
  color: var(--primary-color);
  text-align: center;
  margin: 20px 0;
  font-size: 1rem;
`;

const CommonMessage = styled.div`
  color: var(--primary-color);
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 0.8rem;
  text-align: left;
`;

function RouletteEvent({ userInfo, onComplete, gameType, onStart4x4Puzzle, onStartDripBattle, gameResult, hasAlreadyWon }) {
  const [rouletteData, setRouletteData] = useState(null);
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(8);
  const [showResult, setShowResult] = useState(false);
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadRouletteData();
  }, []);



  const loadRouletteData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await getRoulettePrizes();
      setRouletteData(data);
    } catch (err) {
      //console.error('룰렛 데이터 로드 실패:', err);
      setError('룰렛 정보를 불러오는데 실패했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSpinClick = () => {
    if (!mustSpin) {
      // 상품별 확률에 따라 결과 결정
      const random = Math.random();
      //console.log('random', random);
      let cumulativeProbability = 0;
      let selectedPrizeIndex = 8; /// 꽝이 기본값
      
      // 확률에 따라 상품 선택
      for (let i = 0; i < rouletteData.prizes.length; i++) {
        cumulativeProbability += rouletteData.prizes[i].probability;
        //console.log('cumulativeProbability', cumulativeProbability);
        if (random < cumulativeProbability) {
          selectedPrizeIndex = i;
          //console.log('selectedPrizeIndex', rouletteData.prizes[selectedPrizeIndex].option);
          break;
        }
      }
      
      setPrizeNumber(selectedPrizeIndex);
      setMustSpin(true);
    }
  };

  const handleStopSpinning = async () => {
    setMustSpin(false);
    
    const selectedPrize = rouletteData.prizes[prizeNumber];
    const isWin = !selectedPrize.isLose;
    
    setResult({
      isWin,
      prizeName: selectedPrize.option,
      message: isWin 
        ? `축하합니다!\n${selectedPrize.option}에 \n당첨되었습니다!` 
        : "아쉽게도 꽝입니다.\n다음 기회에 다시 도전해보세요!"
    });

    // 당첨인 경우에만 파이어베이스에 저장 (꽝이 아닌 경우)
    if (isWin && userInfo) {
      try {
        // 룰렛 결과 저장
        await saveRouletteResult({
          nickname: userInfo.nickname, // 닉네임 직접 사용
          prizeName: selectedPrize.option,
          phone: userInfo.phone
        });
          } catch (error) {
      //console.error('룰렛 결과 저장 실패:', error);
        // 저장 실패해도 사용자에게는 결과를 보여줌
      }
    }
    
    setShowResult(true);
  };

  const handleResultClose = () => {
    setShowResult(false);
    if (onComplete) {
      onComplete();
    }
  };

  if (isLoading) {
    return (
      <RouletteContainer>
        <LoadingSpinner>룰렛 정보를 불러오는 중...</LoadingSpinner>
      </RouletteContainer>
    );
  }

  if (error) {
    return (
      <RouletteContainer>
        <ErrorMessage>{error}</ErrorMessage>
        <SpinButton onClick={loadRouletteData}>다시 시도</SpinButton>
      </RouletteContainer>
    );
  }

  if (!rouletteData) {
    return (
      <RouletteContainer>
        <ErrorMessage>룰렛 정보를 불러올 수 없습니다.</ErrorMessage>
      </RouletteContainer>
    );
  }

  return (
    <RouletteContainer gameType={gameType} hasAlreadyWon={hasAlreadyWon}>
      {/* <RouletteCard> */}
        {/* 이미 당첨된 사용자에게는 휠 숨기기 */}
        {!hasAlreadyWon && (
          <>
          {/* <Title>🎰 룰렛 이벤트</Title> */}
          <Subtitle>
            <strong style={{fontSize: '1.2rem', color: '#ffffff'}}>응모가 성공적으로 완료되었습니다!</strong><br />
            지금 바로 룰렛을 돌려 특별한 선물을 만나보세요😊
          </Subtitle>
            <WheelContainer>
              <Wheel
                mustStartSpinning={mustSpin}
                prizeNumber={prizeNumber}
                data={rouletteData.prizes}
                onStopSpinning={handleStopSpinning}
                backgroundColors={[
                  '#8E9AAF', // 톤다운된 블루그레이
                  '#E8A87C', // 부드러운 피치 오렌지
                  '#A2D5AB', // 편안한 민트
                  '#F4978E', // 살짝 채도 낮춘 코랄
                  '#FFD6A5', // 누디 오렌지 (밝은 톤)
                  '#AEC6CF'  // 파스텔 블루그레이
                ]}
                textColors={['#3d3d3d']}  //#3d3d3d → 어두우니까 흰색
                fontSize={16}
                radiusLineWidth={2}
                radiusLineColor={'#FFFFFF'}
                outerBorderWidth={3}
                outerBorderColor={'#FFFFFF'}
                innerBorderWidth={2}
                innerBorderColor={'#FFFFFF'}
                innerRadius={5}
                spinDuration={0.8}
              />
            </WheelContainer>
            
            <SpinButton onClick={handleSpinClick} disabled={mustSpin}>
              {mustSpin ? '돌리는 중...' : '룰렛 돌리기'}
            </SpinButton>
            {/* </RouletteCard> */}
            {showResult && (
              <ResultModal>
                <ResultCard>
                  <ResultTitle $isWin={result.isWin}>
                    {result.isWin ? '🎉 당첨!' : '😢 꽝'}
                  </ResultTitle>
                  {/* <ResultMessageContainer $isWin={result.isWin}> */}
                    {/* <ResultMessageTitle $isWin={result.isWin}>
                      {result.isWin ? '축하합니다!' : '아쉽게도'}
                    </ResultMessageTitle> */}
                    <ResultMessageText>
                      {result.isWin ? (
                        <>
                          <PrizeHighlight>{result.prizeName}</PrizeHighlight>에 당첨되셨습니다!
                        </>
                      ) : (
                        <>
                          아쉽게도 꽝입니다.
                          <br />
                          다음 기회에 다시 도전해보세요!
                        </>
                      )}
                    </ResultMessageText>
                  {/* </ResultMessageContainer> */}
                  <CommonMessage>
                    <span style={{fontSize: '0.7rem', wordBreak: 'keep-all'}}>* 경품 응모 추첨의 경우 9월 8일(월)부터 개별 안내되며, <br/>모든 리워드(경품 및 룰렛 기프티콘 포함)는 9월 15일(월)부터 순차 발송됩니다.</span>
                  </CommonMessage>
                  <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                  <ResultButton onClick={handleResultClose} gameType={gameType} gameStage={gameResult.stage}>
                    확인
                  </ResultButton>
                  {/* 확률 UP 버튼 표시 */}
                  {gameType === 'puzzle' && onStart4x4Puzzle && gameResult && gameResult.stage === 1 && (
                  <ChallengeButton onClick={onStart4x4Puzzle} gameType={gameType} gameStage={gameResult.stage}>
                    🧩 4×4 도전하고{'\n'}당첨 확률 UP
                  </ChallengeButton>
                  )}
                  {gameType === 'dripBattle' && onStartDripBattle && (
                  <ChallengeButton onClick={onStartDripBattle} gameType={gameType}>
                    💬 다른 드립치고{'\n'}당첨 확률 UP
                  </ChallengeButton>
                  )}
                </div>
              </ResultCard>
            </ResultModal>
          )}
      </>
    )}
    {hasAlreadyWon && (
      <>
      <ResultModal>
        <ResultCard  hasAlreadyWon={hasAlreadyWon}>
          <ResultTitle hasAlreadyWon={hasAlreadyWon}>
            응모가 성공적으로 완료되었습니다!
          </ResultTitle>
            
          <CommonMessage>
          <span style={{fontSize: '0.7rem', wordBreak: 'keep-all'}}>* 경품 응모 추첨의 경우 9월 8일(월)부터 개별 안내되며, <br/>모든 리워드(경품 및 룰렛 기프티콘 포함)는 9월 15일(월)부터 순차 발송됩니다.</span>
          </CommonMessage>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
            <ResultButton onClick={handleResultClose} gameType={gameType} gameStage={gameResult.stage}>
              확인
            </ResultButton>
            {/* 확률 UP 버튼 표시 */}
            {gameType === 'puzzle' && onStart4x4Puzzle && gameResult && gameResult.stage === 1 && (
              <ChallengeButton onClick={onStart4x4Puzzle}>
                🧩 4×4 도전하고{'\n'}당첨 확률 UP
              </ChallengeButton>
            )}
            {gameType === 'dripBattle' && onStartDripBattle && (
              <ChallengeButton onClick={onStartDripBattle}>
                💬 다른 드립치고{'\n'}당첨 확률 UP
              </ChallengeButton>
            )}
          </div>
        </ResultCard>
      </ResultModal>
      </>
    )}
    </RouletteContainer>
  );
}

export default RouletteEvent; 